// extracted by mini-css-extract-plugin
export default {"Skills":"Skills_Skills__+O1Th","content":"Skills_content__5CjKO"};